module.exports = __webpack_public_path__ + "img/IDS_CTMS.c6d51625.png";